// Tariff/TariffCard.tsx

import React from 'react';
import {Link, useLocation} from 'react-router-dom';
import {ITariff} from '../../Types/psychology/tariff';
import {FC} from 'WideLayout/Layouts';
import {useTheme} from 'Theme/ThemeContext';

interface TariffCardProps {
    tariff: ITariff;
}

const TariffCard: React.FC<TariffCardProps> = ({tariff}) => {
    const {plt} = useTheme();
    const location = useLocation();
    const linkTo = location.pathname.includes('cabinet')
        ? `/cabinet/tariff/${tariff.id}`
        : `/tariff/${tariff.id}`;

    return (
        <FC
            p={2}
            cursorPointer
            cls={'hover-scale-4'}
            rounded={3}
            w={345}
            bg={`${plt.colors.secondary.light}33`}
            color={plt.text.primary80}
        >
            <Link
                to={linkTo}
                style={{color: plt.text.primary80}}
                className="text-decoration-none flex-grow-1"
            >
                <FC g={1} h={'100%'}>
                    <FC>
                        <h5>{tariff.name}</h5>
                        <p style={{whiteSpace: 'pre-wrap'}}>{tariff.description}</p>
                    </FC>
                    <FC mt={'auto'}>
                        <span>Содержит {tariff.products.length} продуктов</span>
                    </FC>
                </FC>
            </Link>
        </FC>
    );
};

export default TariffCard;
